/* @flow strict */

export const deferImport = (promise, timeout): Promise =>
  new Promise(resolve => setTimeout(() => resolve(promise), timeout));
